import React, { Component } from 'react';

import { opbcdtService } from '../../services';
import Pagination from '../Common/Pagination';
import { utilHelper } from '../../helpers';

class HistoryMng extends Component {
    constructor(props) {
        super(props);
        this.state = {
            historyList: "",
            totalCount: 1,
            totalPage: 1,
            currentPage: 1,
            start: 1,
            open: false,
            isMobile: false,
        }

        this.getHistoryList();
    }

    componentDidMount = () => {
        window.addEventListener("resize", this.resize.bind(this));
        this.resize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize.bind(this));
    }

    resize() {
        let isMobile = (window.innerWidth < 992);
        if (isMobile !== this.state.isMobile) {
            this.setState({ isMobile: isMobile });
        }
    }

    getHistoryList = async () => {
        let formData = new FormData();
        formData.append('opbID', this.props.opbID);
        formData.append('listCount', 10);
        formData.append('currentPage', this.state.currentPage);
        opbcdtService.getRecords(formData)
            .then(response => {
                console.log("HistoryMng > getHistoryList");
                console.log(response.data);
                this.setState({
                    historyList: response.data.adminLogList,
                    totalCount: response.data.totalCount,
                    currentPage: response.data.currentPage,
                    totalPage: response.data.totalPage,
                    start: response.data.start,
                });
            })
            .catch(this.handleErrors)
    };

    getCurrentPage = (currentPage) => {
        this.setState({
            currentPage: currentPage
        }, () => { this.getHistoryList(); })
    };

    handleClickOpen = () => {
        this.setState({
            open: true
        })
    };

    handleClose = () => {
        this.setState({
            open: false,
        });
    };

    render() {
        const { historyList, totalCount, start, isMobile } = this.state;

        const cellList = ["NO", "날짜/시간", "수정내용", "작성자"];

        return (
            <>
                {/* <!-- 현장정보_수정이력 --> */}
                <div className="s-cont-wrap">
                    <div className="s-flex-auto">
                        <div className="s-table-wrap" style={{ width: isMobile ? "400px" : "100%" }}>
                            <table className="w100per">
                                <colgroup>
                                    <col style={{ width: "10%" }} />
                                    <col style={{ width: isMobile ? "30%" : "20%" }} />
                                    <col style={{ width: isMobile ? "35%" : "50%" }} />
                                    <col style={{ width: isMobile ? "25%" : "20%" }} />
                                </colgroup>
                                <thead className="table-head" >
                                    <tr>
                                        {cellList.map((cell, index) => {
                                            return <th key={index} scope="col">{cell}</th>
                                        })}
                                    </tr>
                                </thead>
                                <tbody className="table-body">
                                    {(historyList && historyList.length > 0)
                                        ?
                                        historyList.map((history, i) => {
                                            return <HistoryItem key={i} no={totalCount - (start + i) + 1} history={history} />;
                                        })
                                        :
                                        //  <!-- 입력된 로그가 없을 경우 -->
                                        <tr>
                                            <td colSpan={cellList.length} className="text-align-center">입력된 로그가 없습니다.</td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <Pagination list={this.state} getCurrentPage={this.getCurrentPage} />
                </div>
                {/*<!--// 세팅 본문 컨테이너 -->*/}
            </>
        )
    }
}

function HistoryItem({ no, history }) {

    return (
        <tr className="text-align-center">
            <td data-label="NO">{no}</td>
            <td data-label="날짜/시간">{utilHelper.getStringDate(new Date(history.regDate))}<br />{utilHelper.getStringTime(new Date(history.regDate))}</td>
            <td data-label="수정내용" className="text-align-left">{history.name}</td>
            <td data-label="작성자">{history.userName}</td>
        </tr>
    );
}


export default HistoryMng;